<template>
    <div v-show="show" class="background">
        <div id="white-board-background" class="window-scale" :style="{top:`${this.centerTop}px`}"
            ref="whiteBoard">
            <div id="bar">
                <div id="scroll-page-container" ref="scrollPageContainer">
                    <div class="page-container">
                        <div class="page-item" :class="{ select: currentPageIndex == index }" v-for="(page, index) in pages"
                            :key=page :id="'page-' + (pages.length - index - 1)" @click="switchPage(index)"
                            @dblclick="editPage(index)">
                            {{ page.name }}
                            <img class="delete-btn" src="../../assets/art/white_board/btn_remove.svg"
                                @click.stop.prevent="deletePage(index)" @dblclick.stop.prevent="" @change.stop.prevent="" />
                        </div>
                    </div>
                </div>
                <div id="scroll-page-btns">
                    <img id="scroll-left" class="btn" v-show="showPageBtnScroll" src="../../assets/art/white_board/btn_previous.svg"
                        @click="scrollPageContainer(true)" />
                    <img id="scroll-right" class="btn" v-show="showPageBtnScroll" src="../../assets/art/white_board/btn_next.svg"
                        @click="scrollPageContainer(false)" />
                    <img id="add" class="btn" src="../../assets/art/white_board/btn_add.svg" @click="addPage()" />
                    <img id="colorEditor" class="btn" src="../../assets/art/white_board/icons_palette.svg"
                        @click="openPalette()" />
                </div>
                <select id="background-selector" @change="chooseBackground($event)"
                    v-model="pages[currentPageIndex].backgroundIndex">
                    <option v-for="(option, index) in imageOptions" :key=option.key :value=index
                        :id="'option-' + (index + 1)">
                        {{ option.key }}
                    </option>
                </select>
                <img class="left btn" src="../../assets/art/white_board/btn_close.svg" @click.stop="closeBoard" />
                <img class="right btn" src="../../assets/art/white_board/btn_close.svg" @click.stop="closeBoard" />
            </div>
            <div class="canvas-container">
                <canvas
                    :class="('background-image-' + pages[currentPageIndex].backgroundIndex + ' ' + 'background-color-' + pages[currentPageIndex].backgroundColorIndex)"
                    id="white-board-canvas" width="1437" height="860"></canvas>
            </div>
            <WhiteBoardPalette v-show="showPalette" @chooseBackgroundColor="chooseBackgroundColor"
                @closeEditPage="closeEditPage" :colorOptions="colorOptions" />
        </div>
        <WhiteBoardEditor v-show="showEditer" @closeEditPage="closeEditPage" />
        <ConfirmDialog ref="confirmDialog" />
        <AlertDialog ref="alertDialog" />
    </div>
</template>

<script>
import PainterProxy from '@/js/painter/proxy';
import WhiteBoardEditor from '../UI/WhiteBoardEditor.vue';
import WhiteBoardPalette from '../UI/WhiteBoardPalette.vue';
import ConfirmDialog from '../dialogs/ConfirmDialog.vue';
import AlertDialog from '../dialogs/AlertDialog.vue';
import { bookPageStore } from '../../js/store/bookPageStore';
import { focusStore } from '../../js/store/nowFocusStore';
import { store } from '@/store';
export default {
    components: { WhiteBoardEditor, WhiteBoardPalette, ConfirmDialog, AlertDialog },
    name: "WhiteBoard",
    data: function () {
        return {
            store,
            show: false,
            showEditer: false,
            showPalette: false,
            painterProxy: null,
            showPageBtnScroll: false,
            maxPageCount: 15,
            pages: [
                { name: "頁面 1", paint: null, backgroundIndex: 0, backgroundColorIndex: 0 },
            ],
            imageOptions: [
                { key: "請選擇...", value: 0 },
                { key: "白板1", value: 1 },
                { key: "白板2", value: 2 },
                { key: "白板3", value: 3 },
                { key: "大方格", value: 4 },
                { key: "小方格", value: 5 },
                { key: "五線譜", value: 6 },
                { key: "習字格1", value: 7 },
                { key: "習字格2", value: 8 },
                { key: "英文四格線", value: 9 },
                { key: "格子點", value: 10 },
            ],
            colorOptions: [
                { key: "#FFFFFF", value: 0 },
                { key: "#DDDDDD", value: 1 },
                { key: "#000000", value: 2 },
                { key: "#CCCCFF", value: 3 },
                { key: "#CCEEFF", value: 4 },
                { key: "#CCFF99", value: 5 },
                { key: "#FFFFBB", value: 6 },
                { key: "#FFCCCC", value: 7 }
            ],
            currentPageIndex: 0,
            currentBackgroundIndex: 0,
            currentBackgroundColorIndex: 0,
            centerTop: 0
        };
    },
    methods: {
        openBoard() {
            const self = this;

            this.show = true;
            bookPageStore.isHidden = true;
            this.setCurrentPaint();
            focusStore.setEmptyPageItemControl("whiteBoard");

            this.$nextTick(function () {
                self.centerTop = (store.globalPaintData.height - self.$refs.whiteBoard.offsetHeight * store.windowScale) / 2;
            })
        },
        closeBoard() {
            PainterProxy.getInstance().getCurrentPainter().painter.canvas.discardActiveObject();
            this.show = false;
            bookPageStore.isHidden = false;
            console.log("close board");
            PainterProxy.getInstance().removeCurrentPainter();
            store.clearDisabledTools();
        },
        addPage() {
            if (this.pages.length == this.maxPageCount) {
                this.$refs.alertDialog.showDialog("提示！", `電子畫板數量超過上限${this.maxPageCount}個。`, () => { });
                return;
            }

            this.pages.push({
                name: (this.pages.length + 1).toString(),
                paint: null,
                backgroundIndex: 0,
                backgroundColorIndex: 0
            });
            this.$refs.scrollPageContainer.scrollLeft = this.$refs.scrollPageContainer.scrollWidth - this.$refs.scrollPageContainer.clientWidth;
            this.switchPage(this.pages.length - 1);
        },
        checkPageBtnScroll() {
            let element = document.getElementsByClassName("page-container")[0];
            this.showPageBtnScroll = element.scrollWidth > element.clientWidth;
        },
        openPalette() {
            this.showPalette = !this.showPalette;
        },
        editPage() {
            this.showEditer = true;
        },
        closeEditPage(args) {
            if (args.length > 0) {
                const message = args[0];

                if (message) {
                    this.pages[this.currentPageIndex].name = message;
                }
            }

            this.showEditer = false;
            this.showPalette = false;
        },
        switchPage(pageIndex) {
            if (this.currentPageIndex == pageIndex) return;

            this.pages[this.currentPageIndex].paint = PainterProxy.getInstance().getSave();
            PainterProxy.getInstance().clearAll(false);
            PainterProxy.getInstance().initHistory();

            this.currentPageIndex = pageIndex;

            if (this.pages[this.currentPageIndex].paint != null) {
                PainterProxy.getInstance().loadSave(this.pages[this.currentPageIndex].paint);
            }
            this.currentBackgroundIndex = this.pages[this.currentPageIndex].backgroundIndex;
            this.currentBackgroundColorIndex = this.pages[this.currentPageIndex].backgroundColorIndex;
        },
        deletePage(pageIndex) {
            if (this.pages.length <= 1) {
                this.$refs.alertDialog.showDialog("提示！", "至少需保留一個畫布", () => { });
                return;
            }

            this.$refs.confirmDialog.showDialog("警告", "確定要刪除嗎？", () => {
                if (this.currentPageIndex >= pageIndex && this.currentPageIndex > 0) this.currentPageIndex--;

                this.pages = this.pages.filter((value, index) => {
                    return index != pageIndex
                })

                if (this.pages[this.currentPageIndex] && this.pages[this.currentPageIndex].paint != null) {
                    PainterProxy.getInstance().loadSave(this.pages[this.currentPageIndex].paint);
                }
            }, null, "刪除");
        },
        scrollPageContainer(isLeft = true) {
            if (isLeft) {
                this.$refs.scrollPageContainer.scrollLeft -= 100;
            } else {
                this.$refs.scrollPageContainer.scrollLeft += 100;
            }
        },
        chooseBackground(e) {
            this.pages[this.currentPageIndex].backgroundIndex = e.target.selectedIndex;
        },
        chooseBackgroundColor(e) {
            this.pages[this.currentPageIndex].backgroundColorIndex = e.target.attributes.selectedcolor.value;
            ;
        },
        setCurrentPaint() {
            PainterProxy.getInstance().setCurrentPainter("white-board-canvas");
        }
    },
    mounted() {
        PainterProxy.getInstance().setPainter("white-board-canvas", false, true);
        PainterProxy.getInstance().setCurrentPainter("white-board-canvas");
    },
    watch: {
        "store.globalPaintData": {
            handler: function () {
                this.centerTop = (store.globalPaintData.height - this.$refs.whiteBoard.offsetHeight * store.windowScale) / 2;
            }
        },
        "pages":  {
            handler: function () {
                this.checkPageBtnScroll();
            },
            deep: true
        }
    }
};
</script>

<style src="../../assets/css/WhiteBoard.css" scoped>

</style>
